import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getFullName } from 'screens/DashboardScreen/components/SpeakerModal/speaker-utils';
import { BeeyLocale } from 'libs/locales/locale';
import ResponsiveTable, { useTableView } from 'components/ResponsiveTable';
import { txt } from 'libs/i18n';
import { useSession } from 'components/Authenticated';
import SpeakerNameText from '../../SpeakerNameText';
import { RolesCell } from '../../RolesCell';
import { SpeakerIdActiveIcon } from '../../SpeakerIdActiveIcon';
const DETAIL_TABLE_ID = 'speaker-detail-table';
export const buildRows = (speaker) => {
    const localizationKeys = Object.keys(speaker.localizations);
    const defaultLocKey = speaker.neutralData.defaultLocalisation;
    return localizationKeys.map((locKey) => {
        const loc = speaker.localizations[locKey];
        const { nameVariants, defaultVariantIndex } = loc;
        const defVariant = nameVariants[defaultVariantIndex];
        const beeyLocale = BeeyLocale.fromCode(locKey);
        const variantRows = nameVariants.map((variant, idx) => ({
            key: `${speaker.neutralData.uniqueId}-${locKey}-${idx}`,
            rowType: 'variant',
            name: getFullName(variant.firstName, variant.lastName),
            roles: variant.roles,
            defaultRoleIndex: variant.defaultRoleIndex,
            locale: beeyLocale,
            isDefault: idx === defaultVariantIndex,
        }));
        return {
            key: `${speaker.neutralData.uniqueId}-${locKey}`,
            rowType: 'localization',
            name: getFullName(defVariant.firstName, defVariant.lastName),
            roles: defVariant.roles,
            defaultRoleIndex: defVariant.defaultRoleIndex,
            locale: beeyLocale,
            isDefault: locKey === defaultLocKey,
            speakerIdActive: loc.speakerIdActive,
            children: nameVariants.length >= 1 ? variantRows : undefined,
        };
    });
};
const SpeakerDetailTable = ({ speakerData }) => {
    const tableView = useTableView(DETAIL_TABLE_ID, { pageSize: 5 });
    const { session } = useSession();
    const rows = speakerData !== null ? buildRows(speakerData) : [];
    const isSpeakerIdEnabled = session.login.hasClaim('speakerId:enabled');
    const columns = useMemo(() => [
        {
            title: txt('name'),
            key: 'name',
            width: '230px',
            render: (_, record) => (_jsx(SpeakerNameText, { locale: record.locale, name: record.name, isDefault: record.isDefault })),
        },
        {
            title: txt('roles'),
            key: 'roles',
            render: (_, record) => (_jsx(RolesCell, { rowType: record.rowType, roles: record.roles, defaultRoleIndex: record.defaultRoleIndex })),
        },
        ...(isSpeakerIdEnabled ? [
            {
                title: txt('autodetection'),
                key: 'speakerIdActive',
                width: '120px',
                render: (_, record) => (_jsx(SpeakerIdActiveIcon, { active: record.speakerIdActive })),
            },
        ] : []),
    ], [isSpeakerIdEnabled]);
    return (_jsx(ResponsiveTable, { bordered: false, tableView: tableView, columns: columns, dataSource: rows, loading: speakerData === null, expandable: { defaultExpandAllRows: true }, paginationDisplaySize: "small", showSizeChanger: false, pagination: rows.length > 6 ? {} : false }));
};
export default SpeakerDetailTable;
